module.exports = __webpack_public_path__ + "img/sterling_bank.2af9e262.svg";